import { useContext } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

import { Stack } from "capitalrx-components-2.0/lib/layout";
import { queryString } from "capitalrx-utilities";

import { Body, Button } from "@/basic/components";
import { ThemeSelectorContext } from "@/basic/context";

import styles from "./styles.module.scss";

export const NotFoundContent = () => {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();

  const { client } = useContext(ThemeSelectorContext);
  const params = queryString.convertJsonToQueryString({ client: client });

  const handleButtonClick = () => {
    navigate({
      pathname: "/",
      search: params,
    });
  };

  const handleCapRxButtonClick = () => {
    location.href = "http://cap-rx.com";
  };

  return (
    <Stack alignment="center">
      <div className={styles["PageTitle"]}>404</div>
      <Body>{translate("NOT_FOUND_CONTENT.canNotFindPage")}</Body>
      {params ? (
        <Button className={styles["PageButton"]} onClick={handleButtonClick}>
          {translate("NOT_FOUND_CONTENT.goHome")}
        </Button>
      ) : (
        <Button className={styles["PageButton"]} onClick={handleCapRxButtonClick}>
          {translate("NOT_FOUND_CONTENT.visitCapRx")}
        </Button>
      )}
    </Stack>
  );
};
